import { useState } from "react";
import { useTranslation } from "react-i18next";
export default function Input({ label, name, type="text", placeholder, value, onChange,
  error, note, optional=false, required=false }) {
  const [focused, setFocused] = useState(false);
  const { t } = useTranslation();
  return (
    <div style={{ marginBottom:"16px" }}>
      {label && (
        <div style={{ display:"flex", justifyContent:"space-between", marginBottom:"6px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155" }}>
            {label}{required&&<span style={{color:"#EF4444",marginLeft:"4px"}}>*</span>}
          </label>
          {optional&&<span style={{fontSize:"11px",color:"#94A3B8",fontStyle:"italic"}}>{t("common.optional")}</span>}
        </div>
      )}
      <input name={name} type={type} placeholder={placeholder} value={value}
        onChange={onChange} onFocus={()=>setFocused(true)} onBlur={()=>setFocused(false)}
        style={{ width:"100%", padding:"12px 16px",
          border:"1.5px solid " + (error?"#F87171":focused?"#1CBCD3":"#E2E8F0"),
          borderRadius:"12px", fontSize:"14px", fontFamily:"'DM Sans',sans-serif",
          color:"#1E293B", background:"#fff", outline:"none", boxSizing:"border-box" }} />
      {error&&<p style={{marginTop:"5px",fontSize:"11px",color:"#EF4444"}}>{error}</p>}
      {note&&<p style={{marginTop:"5px",fontSize:"11px",color:"#94A3B8"}}>{note}</p>}
    </div>
  );
}
